module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$tx(_vm.buttonText, _vm.buttonTextCode || _vm.buttonTextEnglish)) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0747810f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/button/src/main.vue
// module id = 2069
// module chunks = 137